import { Injectable, NgZone } from '@angular/core';
import { SplunkAnalyticsService } from '../splunk-analytics/splunk-analytics-service';
import { ObservablesService } from '../observables/observables';
import { StoreService } from '../store';
import { ModalService } from '../modal-factory/modal-factory';

interface ElementsViewModel {
	element: HTMLElement;
	label: string;
	route: string;
}

@Injectable()
export class ScrollEventHandlerService {
	elements: { [key: number]: ElementsViewModel } = {};
	modalWindow: HTMLElement;
	lastStage: string;
	constructor(
		private storeService: StoreService,
		private splunkService: SplunkAnalyticsService,
		private modalFactory: ModalService,
		private observablesService: ObservablesService
	) {
		this.observablesService.pageUpdated.subscribe((pageUpdateEvent) => {
			if (this.lastStage !== pageUpdateEvent.page) {
				if (this.lastStage != null) {
					this.elements = {};
				}
				this.lastStage = pageUpdateEvent.page;
			}
		});
		this.registerScrollEvent();
	}

	registerDisplayOnScroll(element: HTMLElement, controlName: string, label: string, route?: string) {
		return false;
	}

	addElem(element: HTMLElement, controlId: string, label: string, route?: string) {
		if (route) {
			this.elements[controlId] = { element, label, route };
		} else {
			this.elements[controlId] = { element, label };
		}
		this.checkOnInit(element, controlId);
	}

	removeElem(element: HTMLElement, controlName: string) {
		delete this.elements[controlName];
	}

	registerScrollEvent(): void {
		// this.ngZone.runOutsideAngular(() => {

		let debounce = (method, delay) => {
			clearTimeout(method._tId);
			method._tId = setTimeout(function () {
				method();
			}, delay);
		};

		let loop = () => {
			for (const id in this.elements) {
				const item = this.elements[id];
				this.fireEvent(item);
			}
		};
		loop.bind(this);

		let loopDebounceFunc = () => {
			debounce(() => {
				setTimeout(() => {
					loop();
				}, 1);
			}, 1000);
		};

		window.addEventListener('scroll', loopDebounceFunc, false);

		this.modalFactory.allModalControlsGenerated$.subscribe(() => {
			loop();
			this.modalWindow = document.querySelector('.modal.info-we-found-mvp');
			this.modalWindow.addEventListener('scroll', loopDebounceFunc, false);
		});
	}

	// resetScroll() {
	//   this.scrollEvent = null;
	// }

	isInViewport(elem, label) {
		let distance = elem.getBoundingClientRect();
		let distBottom = distance.bottom;
		let distTop = distance.top;

		if (label && label === 'CompareRates_Displayed') {
			let globalAttributes = this.storeService.getGlobalAttributes();
			if (globalAttributes && globalAttributes.shouldFireCompareRatesGaEvent) {
				distBottom = distance.bottom - (distance.bottom - distance.top) / 2 + 100;
				distTop = distance.top + (distance.bottom - distance.top);
			} else {
				return false;
			}
		}
		if (label && (label === 'HomeAndPersonalCoverages_Displayed' || label === 'Deductibles_Displayed')) {
			let globalAttributes = this.storeService.getGlobalAttributes();
			if (globalAttributes && globalAttributes.showComparison) {
				return false;
			}
		}
		let inViewPort =
			!(distTop === 0 && distance.left === 0 && distBottom === 0 && distance.right === 0) &&
			distTop >= 0 &&
			distance.left >= 0 &&
			distBottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			distance.right <= (window.innerWidth || document.documentElement.clientWidth);
		return inViewPort;
	}

	checkOnInit(element, id) {
		this.fireEvent(this.elements[id]);
	}

	fireEvent(item) {
		if (this.isInViewport(item.element, item.label)) {
			setTimeout(() => {
				this.splunkService.pushDisplayOnce(item.label, item.route);
			}, 1);
		}
	}
}
